import { Field } from 'redux-form';
import { required } from './../../components/validations';
import {
  isValidNameWithSpace,
  normalizeDecimal,
  normalizeHoursAndMinutes,
  renderAutoCompleteMultipleSelection,
  renderAutoCompleteSingleSelect,
  renderCheckBox,
  renderDateField,
  renderServersideAutocomplete,
  renderTextArea,
  renderTextField,
  renderTimePicker,
  renderCustomRadioButtons,
} from './../../components/reduxFields';
import React from 'react';
import Recurrence from '../../components/recurrenceRule';
import GooglePlaceAutocomplete from './../../components/GooglePlaceAutocomplete';
// import { AIP, EBS, VIP } from '../../actions/utilAction';

// import { getInputFieldSearchData } from './actions/SchedulingActions';
const isCheckForPatientInsurance = true;

const validatePatient = (PatientName) => PatientName ? undefined : 'Please select client';
const validatePatientInsurance =(PatientInsuranceID) => PatientInsuranceID ? undefined : 'Please select insurance';
const validatePatientAuth = (authNo) => authNo ? undefined : 'Please select insurance authorization';
const validateCustomAddressID = (isNonBillableAppointment) => isNonBillableAppointment ? undefined : 'Please select address type';
// const validatePayRateTypeId = (PayRateTypeId) => {
//   if (!PayRateTypeId) {
//     return 'Please select pay rate type.';
//   } else if (!Number.isInteger(PayRateTypeId)) {
//     return 'Please select an option.';
//   }  
// };

function AppointmentDialogForm(props) {

  let {
    appointmentId
    , schedulerPatientId
    , selectorPatientId
    , selectorIsRBTTracking
    // , selectorPatientInsuranceId
    , startDate
    , startTime
    , endTime
    , searched_patients
    , appointmentTypes
    , patientInsuranceList
    , patientAuthorizationsList
    , dropdownServiceLocations
    , selectedOrganizationLocations
    , value
    , isAppointmentAuthorized
    , authorizationMessage
    , availabilityErrorMessage
    , availabilityClientErrorMessage
    , insuranceErrorMessage 
    , availabilityRemaininAuthMessage
    , isBillableAppointment    
    , isRequiredAuthorization
    , allowMultipleStaff
    , isClientRequired
    , allStaff
    , selectedLocationID
    , edit_in_recurrence
    , IsRecurrence
    , IsExcludeFromMileage
    , isServiceAtCustomAddress
    , dropdownPatientLocationTypes
    , dropdownModeOfMeeting
    , dropdownSupervisionType
    , handleClick
    , rule
    , interval
    , validations
    , RecurrencePattern
    , handleChangeAppointmentType
    , handleChangePatientInsurance
    , handleChangePatientAuthorization
    , handleChangeStaff
    , handleChangeSupervsieeStaff
    , handleChangeOrganizationLocation
    , onChangeHandler
    , handleLocationChange    
    , onDateChange
    , handleRecurrenceChecked
    , handleRuleChange
    , handleIntervalChange
    , handleValidationsChange
    , handleCheckExcludeFromMileage
    , handleChangeNotes
    , handleChangeRBT
    , Notes
    , loadingSearchPatients
    , loadingPatientDetails
    , loadingPatientInsurance
    , viewClientSchedulesPermission
    , GetFullAddress
    , IsFullAddressEmpty
    , isValidAddress
    , customAddress    
    , IsDirectService
    , changeIsDirectService
    , editAppointmentTimeOnlyPermission
    , disableAppointmentEditing
    , isRequestFromPatientPortal // condition over the appointment from the patient portal ...
    , editAppointmentAfterClaimSubmission    
    , IsExcludeFromPayroll
    , handleCheckExcludeFromPayroll
    , showAddressTypeDuringAppointmentCreation    
    , payRateTypeId
    , agencyName
    , clinicalRoomId
    , handleChangeRoom
    , clinicalRoomAvailablityMessage
    , clinicalRoomAvailablityCode
    , IsClientCheckedIn
    , handleCheckClientCheckedIn
    , IsApptTimeEditableAfterRender
    , handleCheckMakeUpSession
    , claimId
    , modifySessionTimeAfterClaimSubmission
    , isUpdateAfterClaimSubmitted
    , updateTimeAfterRenderingTheSessionMessage
    , updateTimeAfterSubmissionTheSessionMessage
    , IsMakeUpSession
    , maxCardIssueEndDate
    , patientEncounterId
    ,modifyAfterRenderPermission
    ,AdminRole
  } = props;

  const isPatientInsuranceRequired = (schedulerPatientId || selectorPatientId) ? true : false;
  const isEditTimeOnlyPermission = (editAppointmentTimeOnlyPermission && appointmentId && IsApptTimeEditableAfterRender);    
  const isDisableAppointmentEditing = (disableAppointmentEditing && appointmentId);

  const isSessionTimeEditPerssion =(isUpdateAfterClaimSubmitted ? !modifySessionTimeAfterClaimSubmission : ((!isEditTimeOnlyPermission && editAppointmentAfterClaimSubmission) || isDisableAppointmentEditing));
  // const isModifyAfterRender = (modifyAfterRenderPermission && !AdminRole)
  const renderLoading = (
    <div className="custom_select">
      <div className="divtr">
        <div className="divth">Client ID</div>
        <div className="divth">Name</div>
        <div className="divth">D.O.B</div>
      </div>
      <div className="divtr"><div className="divtd">loading ...</div></div>
    </div>
  );
  const renderPatients = (patients) => {
    return patients.map((item, index) => {
      let mrnNo = item.mrn_number || '',
        name = item.name || '',
        dob = item.dob || '';
      return (
        <div className="divtr" key={index} onClick={(e) => handleClick(e, item)}>
          <div className="divtd" title={mrnNo}>{mrnNo.length > 5 ? mrnNo.substring(4, 0) + '...' : mrnNo}</div>
          <div className="divtd" title={name}>{name.length > 18 ? name.substring(17, 0) + '...' : name}</div>
          <div className="divtd" title={dob}>{dob}</div>
        </div>
      );
    });
  };
  const renderItems = () => {
    if (searched_patients.length === 0) {
      return false;
    }
    return (
      <div className="custom_select">
        <div className="divtr">
          <div className="divth">Client ID</div>
          <div className="divth">Name</div>
          <div className="divth">D.O.B</div>
        </div>
        {loadingSearchPatients ? renderLoading : renderPatients(searched_patients)}
      </div>);
  };

  // const handleChangeStaff = (input, selectedValue) => {
  //   if (allowMultipleStaff) {
  //     input.onChange(selectedValue);
  //   } else {
  //     input.onChange(selectedValue.value);
  //   }
  // };

  const renderMileageAndDriveTime = () => {
    return (
      <div className="row">
        <div className="col-sm-6">
          <Field
            name="Mileage"
            type="text"
            maxLength="5"
            floatingLabelText="Mileage (in miles)"
            normalize={normalizeDecimal}
            disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing}
            component={renderTextField}
            fullWidth={true}
          />
        </div>
        <div className="col-sm-6">
          <Field
            name="DriveTime"
            type="text"
            maxLength="8"
            floatingLabelText="Drive Time"
            disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing}
            normalize={normalizeHoursAndMinutes}
            component={renderTextField}
            fullWidth={true}
          />
        </div>
      </div>
    );
  };

  const makeupSession = () => {
    return (
      <div className="row">
        <div className="col-sm-12">
          <div className="col-sm-12 ">
            <Field
              name="MakeUpSessionHours"
              type="text"
              maxLength="5"
              floatingLabelText='# of hours'
              disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing}
              normalize={normalizeDecimal}
              component={renderTextField}
              fullWidth={true}
            />
          </div>
        </div>
      </div>
    );
  };


  return (
    <div className="row">
      <div className="col-sm-12">
        <form className="readmin-form custom_form">
          {!isAppointmentAuthorized || availabilityErrorMessage ?
            (<div className="row">
              <div className="col-sm-12">
                <div className="del-cont">
                  <div className="alert-danger mt-10">Note : {authorizationMessage || ''} {authorizationMessage && availabilityErrorMessage ? (<b>&</b>) : ''} {availabilityErrorMessage || ''}</div>
                </div>
              </div>
            </div>) : null}
            {!isAppointmentAuthorized || availabilityClientErrorMessage ?
            (<div className="row">
              <div className="col-sm-12">
                <div className="del-cont">
                  <div className="alert-success mt-10">{availabilityClientErrorMessage || ''}</div>
                </div>
              </div>
            </div>): null}
            {isAppointmentAuthorized && availabilityRemaininAuthMessage ?
              (<div className="row">
              <div className="col-sm-12">
                <div className="del-cont">
                  <div className="alert-success mt-10">{availabilityRemaininAuthMessage || ''}</div>
                </div>
              </div>
            </div>): null}
            {clinicalRoomAvailablityCode === 1 && clinicalRoomAvailablityMessage ?
              (<div className="row">
              <div className="col-sm-12">
                <div className="del-cont">
                  <div className="alert-success mt-10">{clinicalRoomAvailablityMessage || ''}</div>
                </div>
              </div>
            </div>): clinicalRoomAvailablityCode === 2 && clinicalRoomAvailablityMessage ?
              (<div className="row">
              <div className="col-sm-12">
                <div className="del-cont">
                  <div className="alert-danger mt-10">{clinicalRoomAvailablityMessage || ''}</div>
                </div>
              </div>
            </div>) : null
            }
            {updateTimeAfterRenderingTheSessionMessage ?
              (<div className="row">
              <div className="col-sm-12">
                <div className="del-cont">
                  <div className="alert-warning mt-10">{updateTimeAfterRenderingTheSessionMessage || ''}</div>
                </div>
              </div>
            </div>): null}
            {updateTimeAfterSubmissionTheSessionMessage ?
              (<div className="row">
              <div className="col-sm-12">
                <div className="del-cont">
                  <div className="alert-warning mt-10">{updateTimeAfterSubmissionTheSessionMessage || ''}</div>
                </div>
              </div>
            </div>): null}
            {insuranceErrorMessage ?
             (<div className="row">
             <div className="col-sm-12">
               <div className="del-cont">
                 <div className="alert-warning mt-10">{insuranceErrorMessage || ''}</div>
               </div>
             </div>
           </div>): null}
           
          <div className="row">
            <div className="col-sm-6">
              <Field
                name="startDate"
                placeholder="Appointment Date"
                component={renderDateField}
                openToYearSelection={true}
                validate={[required]}
                selected={startDate}
                // disabled={isEditTimeOnlyPermission || editAppointmentAfterClaimSubmission || isDisableAppointmentEditing}
                disabled={isSessionTimeEditPerssion ? true : false}
                onDateChange={onDateChange}
                maxDate={editAppointmentTimeOnlyPermission === false && (patientEncounterId > 0 || !patientEncounterId || claimId > 0) ?
                  // new Date()
                  
                  new Date(maxCardIssueEndDate)
                   : 
                  new Date(2120,9,11)}
                
                locale="en-US"
                fullWidth={true}
              />
            </div>
            <div className="col-sm-3 wd_full">
              <Field
                name="startTime"
                placeholder="Start Time"
                fullWidth={true}
                component={renderTimePicker}
                validate={[required]}
                selected={startTime}
                //disabled={((!isUpdateAfterClaimSubmitted && !isEditTimeOnlyPermission && editAppointmentAfterClaimSubmission) || (!isUpdateAfterClaimSubmitted && isDisableAppointmentEditing)) && (modifySessionTimeAfterClaimSubmission && !isUpdateAfterClaimSubmitted)}
                disabled={isSessionTimeEditPerssion ? true : false}
                onDateChange={onDateChange}

              />
            </div>
            <div className="col-sm-3 wd_full">
              <Field
                name="endTime"
                placeholder="End Time"
                component={renderTimePicker}
                validate={[required]}
                selected={endTime}
                //disabled={((!isUpdateAfterClaimSubmitted && !isEditTimeOnlyPermission && editAppointmentAfterClaimSubmission) || (!isUpdateAfterClaimSubmitted && isDisableAppointmentEditing)) && (modifySessionTimeAfterClaimSubmission && !isUpdateAfterClaimSubmitted)}
                disabled={isSessionTimeEditPerssion ? true : false}
                onDateChange={onDateChange}
                fullWidth={true}
              />
            </div>

            {/* <div className="col-sm-6">
              <Field
                name="endDate"
                placeholder="End Date"
                component={renderDateField}
                validate={[required]}
                selected={endDate}
                onDateChange={onDateChange}
                locale="en-US"
                fullWidth={true}
              />
            </div> */}

          </div>
          {!schedulerPatientId ? (
            <div className='row'>
              <div className="col-sm-6 require mt-40">
                <Field
                  name="SelectedLocationID"
                  label="Location"
                  options={selectedOrganizationLocations}
                  // disabled={isEditTimeOnlyPermission || editAppointmentAfterClaimSubmission || isDisableAppointmentEditing}
                  disabled={isSessionTimeEditPerssion ? true : false}
                  handleNewRequest={handleChangeOrganizationLocation}
                  component={renderAutoCompleteSingleSelect}
                />
              </div>
              <div className={`col-sm-6 ${isClientRequired ? 'require' : ''}`}>
                <Field
                  name="PatientName"
                  type="text"
                  maxLength="50"
                  normalize={isValidNameWithSpace}
                  value={value}
                  floatingLabelText="Client Name"
                  onChange={onChangeHandler}
                  disabled={(appointmentId || !selectedLocationID || !viewClientSchedulesPermission || isEditTimeOnlyPermission || editAppointmentAfterClaimSubmission) ? true : false}
                  validate={isClientRequired ? [validatePatient] : null}
                  component={renderServersideAutocomplete}
                  fullWidth={true}
                />
                {renderItems()}
              </div>
            </div>
          ) : null}
          <div className="row">

          {isCheckForPatientInsurance && (
              <div className={`col-sm-6 mt-40 ${isClientRequired && isPatientInsuranceRequired && 'require'}`}>
                <Field
                  name="PatientInsuranceID"
                  label="Insurance Company"
                  options={patientInsuranceList}
                  // disabled={loadingPatientInsurance || isEditTimeOnlyPermission || editAppointmentAfterClaimSubmission || isDisableAppointmentEditing}
                  disabled={loadingPatientInsurance || (isSessionTimeEditPerssion ? true : false)}
                  handleNewRequest={handleChangePatientInsurance}
                  component={renderAutoCompleteSingleSelect}
                  validate={isClientRequired && isPatientInsuranceRequired ? [validatePatientInsurance] : null} // Validation for insurance
                // customError={!isAppointmentAuthorized ? authorizationMessage : null}
                />
              </div>
            )}

            <div className="col-sm-6 require mt-40">
              <Field
                name="AppointmentTypeID"
                label="Appointment Type"
                options={appointmentTypes}
                // disabled={loadingPatientDetails || isEditTimeOnlyPermission || editAppointmentAfterClaimSubmission || isDisableAppointmentEditing}
                disabled={loadingPatientDetails || (isSessionTimeEditPerssion ? true : false)}
                handleNewRequest={handleChangeAppointmentType}
                component={renderAutoCompleteSingleSelect}
              // customError={!isAppointmentAuthorized ? authorizationMessage : null}
              />
            </div>

            {isCheckForPatientInsurance && (
              <div className={`col-sm-8 ${(isRequiredAuthorization ? 'require' : '')} mt-40`}>
                <Field
                  name="PatientAuthorizationID"
                  label="Client Authorization"
                  options={patientAuthorizationsList}
                  // disabled={(!isRequiredAuthorization ? true : false) || loadingPatientInsurance || isEditTimeOnlyPermission || editAppointmentAfterClaimSubmission || isDisableAppointmentEditing}
                  disabled={(!isRequiredAuthorization ? true : false) || loadingPatientInsurance || (isSessionTimeEditPerssion ? true : false)}
                  handleNewRequest={handleChangePatientAuthorization}
                  validate={isRequiredAuthorization ? [validatePatientAuth] : null}
                  component={renderAutoCompleteSingleSelect}
                  // customError={!isAppointmentAuthorized ? authorizationMessage : null}
                />
              </div>
            )}
            <div className="col-sm-4 require mt-40">
              <Field
                name="StaffIDs"
                label="Employee"
                // options={this.state.staffs}
                disabled={(appointmentId || isEditTimeOnlyPermission || isDisableAppointmentEditing || editAppointmentAfterClaimSubmission) ? true : false}
                options={allStaff}
                // customError={availabilityErrorMessage}
                handleNewRequest={handleChangeStaff}
                component={allowMultipleStaff ? renderAutoCompleteMultipleSelection : renderAutoCompleteSingleSelect}
              />
            </div>
            <div className="col-sm-6 require mt-40">
              <Field
                name="ServiceLocationID"
                label="Service Location"
                options={dropdownServiceLocations}
                disabled={(!selectedLocationID || isEditTimeOnlyPermission || editAppointmentAfterClaimSubmission || isDisableAppointmentEditing) ? true : false}
                handleNewRequest={handleLocationChange}
                component={renderAutoCompleteSingleSelect}
              />
            </div>
            <div className={`col-sm-6 ${isServiceAtCustomAddress ? isBillableAppointment ? 'require mt-40' : 'mt-40' : ''}`}>
              {isServiceAtCustomAddress ? (
                showAddressTypeDuringAppointmentCreation ?
                <Field
                  name="CustomAddressID"
                  label="Address Type"
                  options={dropdownPatientLocationTypes}
                  // disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing}
                  disabled = {isSessionTimeEditPerssion ? true : false}
                  handleNewRequest={(input, selectedValue) => input.onChange(selectedValue.value)}
                  component={renderAutoCompleteSingleSelect}                  
                  validate={isBillableAppointment ? [validateCustomAddressID] : null}
                />
                : null
              ) : (<Field
                name="ServiceAddress"
                type="text"
                floatingLabelText="Service Address"
                disabled={true}
                fullWidth={true}
                component={renderTextField}
              />)}
            </div>
          </div>
          {isServiceAtCustomAddress ?
            (<div className="row">
              <div className="col-sm-12 require">
                {/* <Field
                  name="CustomAddress"
                  type="text"
                  floatingLabelText="Other Address"
                  fullWidth={true}
                  component={renderTextField}
                /> */}
                <GooglePlaceAutocomplete
                  getFullAddress={GetFullAddress}
                  id="CustomAddress"
                  labelText="Other Address"
                  errorText={isValidAddress ? '' : 'Invalid address. Please choose address from dropdown.'}
                  // hintText="Enter Address"
                  // disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing}
                  disabled = {isSessionTimeEditPerssion ? true : false}
                  value={customAddress}
                  IsFullAddress = {true}
                  isFullAddressEmpty={IsFullAddressEmpty}
                />
              </div>
            </div>)
            : null
          }
          {!isRequestFromPatientPortal ?
            (<div className="row">
             {!isCheckForPatientInsurance ?
              <div className="col-sm-3 mt-40" >
                <Field
                  name="IsTelehealthAppointment"
                  label="Video"
                    disabled={isEditTimeOnlyPermission || editAppointmentAfterClaimSubmission || isDisableAppointmentEditing}
                  component={renderCheckBox}
                />
              </div>
              : null}
              <div className={isCheckForPatientInsurance ? "col-sm-3 mt-40" : "col-sm-3 mt-40"}>
                <Field name="IsDirectService"
                  options={[{ id: 1, value: 'Direct' }, { id: 0, value: 'Indirect' }]}
                  selectedValue={IsDirectService}
                  onChange={changeIsDirectService}
                  // disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing || editAppointmentAfterClaimSubmission}
                  disabled={isSessionTimeEditPerssion ? true : false}
                  component={renderCustomRadioButtons} />
              </div>
              <div className={isCheckForPatientInsurance ? "col-sm-3 mt-40" : "col-sm-3 mt-40"}>
                <Field
                  name="IsMakeUpSession"
                  label="Make-Up Session"
                  // disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing || editAppointmentAfterClaimSubmission}
                  disabled={isSessionTimeEditPerssion ? true : false}
                  onChange={handleCheckMakeUpSession}
                  component={renderCheckBox}
                />
                {!isRequestFromPatientPortal && IsMakeUpSession && makeupSession()} 
              </div>
              <div className={isCheckForPatientInsurance ? "col-sm-3 mt-40" : "col-sm-3 mt-40"}>
                <Field
                  name="IsExcludedFromPayroll"
                  label="Exclude From Payroll"
                  // disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing || editAppointmentAfterClaimSubmission}
                  disabled={isSessionTimeEditPerssion ? true : false}
                  onChange={handleCheckExcludeFromPayroll}
                  component={renderCheckBox}
                />
              </div>
              <div className={isCheckForPatientInsurance ? "col-sm-3 mt-40" : "col-sm-3 mt-40"}>
                <Field
                  name="IsExcludedFromMileage"
                  label="Exclude From Mileage"
                  // disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing || editAppointmentAfterClaimSubmission}
                  disabled={isSessionTimeEditPerssion ? true : false}
                  onChange={handleCheckExcludeFromMileage}
                  component={renderCheckBox}
                />
              </div>
            </div>)
            : null}
          {!isRequestFromPatientPortal && !IsExcludeFromMileage && renderMileageAndDriveTime()}
          <div className="row">
            <div className="col-sm-4 mt-40" >
              <Field
                name="IsRBTTracking"
                label="RBT Supervision"
                // disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing || editAppointmentAfterClaimSubmission}
                disabled={isSessionTimeEditPerssion ? true : false}
                onChange={handleChangeRBT}
                component={renderCheckBox}
              />
            </div>       
            
            <div className={isCheckForPatientInsurance ? "col-sm-4 mt-40" : "col-sm-5 mt-40"}>
              <Field
                name="IsClientCheckedIn"
                label="Client Checked-In"
                // disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing || editAppointmentAfterClaimSubmission}
                disabled={isSessionTimeEditPerssion ? true : false}
                onChange={handleCheckClientCheckedIn}
                component={renderCheckBox}
              />
            </div>
            <div className="col-sm-4 mt-40">
              <Field
                  name="ClinicalRoomId"
                  label="Therapy Room"
                  options={clinicalRoomId}
                  // disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing || editAppointmentAfterClaimSubmission}
                  disabled={isSessionTimeEditPerssion ? true : false}
                  handleNewRequest={handleChangeRoom}
                  //handleNewRequest={(input, selectedValue) => input.onChange(selectedValue.value)}               
                  component={renderAutoCompleteSingleSelect}
                />
            </div>
            {/* {(agencyName.toUpperCase().startsWith(EBS) || agencyName.toUpperCase() === AIP || agencyName.toUpperCase() === VIP) ?             
            <div className="col-sm-6 mt-40">
              <Field
                name="PayRateTypeId"
                label="Pay Rate Type"
                options={payRateTypeId}
                disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing}
                handleNewRequest={(input, selectedValue) => input.onChange(selectedValue.value)}
                //validate={validatePayRateTypeId}
                component={renderAutoCompleteSingleSelect}
              />
            </div>:null}   */}
          </div>
          {selectorIsRBTTracking ?
            <div className="row">
                {/* <div className="col-sm-6 mt-40 require">
                <Field
                  name="SupervsieeStaffId"
                  label="Name of RBT"
                  options={allStaff}
                  disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing}
                  handleNewRequest={(input, selectedValue) => input.onChange(selectedValue.value)}
                  component={renderAutoCompleteSingleSelect}
                />
                  </div> */}
                <div className="col-sm-6 mt-40 require">
                  <Field
                    name="SupervsieeStaffIds"
                    label="Name of RBT"
                    options={allStaff}
                    disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing}
                    handleNewRequest={handleChangeSupervsieeStaff}
                    component={renderAutoCompleteMultipleSelection}
                  />
                </div>
              <div className="col-sm-6 mt-40 require">
                <Field
                  name="ModeOfMeetingId"
                  label="Mode of Meeting"
                  options={dropdownModeOfMeeting}
                  disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing}
                  handleNewRequest={(input, selectedValue) => input.onChange(selectedValue.value)}
                  component={renderAutoCompleteSingleSelect}
                />
              </div>
              <div className="col-sm-6 mt-40 require">
                <Field
                  name="SupervisionTypeId"
                  label="Supervision Type"
                  options={dropdownSupervisionType}
                  disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing}
                  handleNewRequest={(input, selectedValue) => input.onChange(selectedValue.value)}
                  component={renderAutoCompleteSingleSelect}
                />
                  </div>
              <div className="col-sm-6 mt-40">
                <Field
                  name="IsObservedWithclient"
                  label="Observed with Client"
                  disabled={isEditTimeOnlyPermission || isDisableAppointmentEditing}
                  component={renderCheckBox}
                />
              </div>
            </div>
          : null}
          <div className="row">
            <div className="col-sm-12">
              <Field
                name="Notes"
                type="text"
                maxLength="1000"
                floatingLabelText="Notes"
                // disabled={isEditTimeOnlyPermission || editAppointmentAfterClaimSubmission || isDisableAppointmentEditing}
                disabled={isSessionTimeEditPerssion ? true : false}
                // normalize = {isValidNameWithSpace}
                component={renderTextArea}
                onChange={handleChangeNotes}
                fullWidth={true}
              />
              <small className="blackfont font12">{Notes && Notes.length ? `${1000 - Notes.length} characters remaining` : '1000 characters remaining'}</small>
            </div>
          </div>
          {(!appointmentId || (edit_in_recurrence === true && props.initialValues['Recurrence'] === true)) ?
            <div className="row">
              <div className="col-sm-12 mt-20">
                <Field
                  name="Recurrence"
                  floatingLabelText="Recurrence"
                  label="Recurrence"
                  onChange={handleRecurrenceChecked}
                  //disabled={!appointmentId ? false : true }
                  component={renderCheckBox}
                />
              </div>
            </div>
            : null}

          {IsRecurrence ?
            <Recurrence
              rule={rule}
              interval={interval}
              validations={validations}
              RecurrencePattern={RecurrencePattern}
              onRuleChange={handleRuleChange}
              onIntervalChange={handleIntervalChange}
              onValidationsChange={handleValidationsChange}
              recurrenceMinDate={startDate} />
            : ''}
        </form>
        {/* <p><b>{this.state.IsRecurrence ? `FREQ=${this.state.rule};Valid=${this.state.validations};INTERVAL=${this.state.interval}` : ''}</b></p>*/}
      </div>
    </div >
  );
}

export default AppointmentDialogForm;



// WEBPACK FOOTER //
// ./src/modules/scheduling/renderFormContainer.js